import React from 'react';
import PropTypes from 'prop-types';

const CardInfo = ({
  image,
  title,
  winner,
  type,
  description,
}) => {
  return (
    <>
      { type !== 'winner' ? (
        <div className="card-info">
          <div className="header">
            <img
              src={image}
              alt="img-header" />
          </div>
          <div className="body p-15">
            <h3 className="title text-tangaroa f-600">
              {title}
            </h3>
            <div>{description}</div>
          </div>
        </div>

      ) : ''}
      { type === 'winner' ? (
        <div className="card-winner">
          <div className="header">
            <img
              src={image}
              alt="img-header" />
          </div>
          <div className="body p-15 d-flex flex-column justify-content-between">
            <h3 className="title text-tangaroa f-600">
              {title}
            </h3>
            <div className="text-dark-blue winner f-600">
              <i className="fas fa-user-circle mr-2" />
              {winner}
            </div>
          </div>
        </div>
      ) : ''}
    </>
  );
};

CardInfo.defaultProps = {
  image: '',
  title: '',
  winner: '',
  type: '',
  description: '',
};

CardInfo.propTypes = {
  image: PropTypes.string,
  title: PropTypes.string,
  winner: PropTypes.string,
  type: PropTypes.string,
  description: PropTypes.string,
};

export default CardInfo;
